import { Observable, throwError } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { AppConfig } from '../../app.config'
import { Center } from './center.object'
import { ErrorHandlerService } from 'src/app/common/error-handler.service'

export interface CenterSentEmailConfirmation {
  message: string
}

/**
 * this handles all http calls for centers management
 */
@Injectable({
  providedIn: 'root',
})
export class CentersService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private toastr: ToastrService,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  editCenter(newCenter: Center): Observable<object> {
    const url: string = `${this.appConfig.config.server_api.centers.edit}${newCenter.id}/`

    return this.http.patch(url, newCenter.toJSON()).pipe(
      tap(() => {
        const message = `Center ${newCenter.id} successfully edited`
        console.log(message)
        this.toastr.success(message)
      }),
      catchError((error) => {
        const message = "Some error. Can't edit center."
        this.errorHandlerService.showErrorMessage(error, message)
        return throwError(error)
      }),
    )
  }

  sendTestEmail(centerWithNewEmailAddresses: Center): Observable<CenterSentEmailConfirmation> {
    const { send_test_email_prefix, send_test_email_suffix } = this.appConfig.config.server_api.centers
    const url = `${send_test_email_prefix}${centerWithNewEmailAddresses.id}/${send_test_email_suffix}`

    return this.http
      .post<CenterSentEmailConfirmation>(url, centerWithNewEmailAddresses.toJSON())
      .pipe(tap(this.onSendTestEmailSuccess), catchError(this.onSendTestEmailError))
  }

  private onSendTestEmailSuccess(response: CenterSentEmailConfirmation): void {
    console.log(`Sent test email successfully ` + (response instanceof Response))
  }

  private onSendTestEmailError = (response: CenterSentEmailConfirmation): Observable<CenterSentEmailConfirmation> => {
    const message = `Some error. Can't edit center.`
    this.errorHandlerService.showErrorMessage(response, message)
    return throwError(response)
  }

  getCenterTimezones() {
    const url = this.appConfig.config.server_api.centers.get_center_timezones

    return this.http.post<string[]>(url, {})
  }
}
